export default __webpack_public_path__ + "static/media/icon-netlify.66e9d72e.png";